
import Nav from "../nav/Nav";
import AboutHero from "./AboutHero";

function AboutWrapper() {
  return (
    <>
      <Nav />
      <AboutHero />
    </>
  );
}

export default AboutWrapper;
